import * as React from 'react';
import { Button } from '@mui/material';
import { useUserToken } from '../utils/authentication';
import CircularProgress from '@mui/material/CircularProgress';

interface UploadProps {
    edit?: boolean;
    onUpload: (params) => void;
    slateId: string;
}

function Upload(props) {
    const { edit, onUpload, slateId, isUploading = false } = props;
    const userToken = useUserToken();

    const handleFileUpload = (e) => {
        const reader = new FileReader();
        const file = e.target.files[0];

        if (file) {
            reader.onload = async (event) => {
                const csvText = event?.target?.result;
                const params = {
                    slateId,
                    token: userToken,
                    userEntriesCSV: csvText
                };
                onUpload(params);
                // Clear the input value to allow re-uploading the same file
                e.target.value = '';
            };
            reader.readAsText(file);
        }
    };

    const editButtonStyles = edit
        ? {
              background: '#2E2E2E',
              border: 'none',
              fontWeight: 400,
              padding: '4px 6px',
              whiteSpace: 'nowrap',
              '&:hover': {
                  background: '#2E2E2E',
              },
          }
        : {};

    return (
        <Button
            variant='contained'
            color='primary'
            disabled={isUploading} // Disable button when uploading
            sx={{
                borderRadius: '6px',
                padding: '8px 18px',
                color: '#FFFFFF',
                fontWeight: 500,
                fontFamily: 'Inter',
                lineHeight: 'normal',
                display: 'flex',
                alignItems: 'center',
                gap: '8px',
                ...editButtonStyles,
            }}
            component='label' // Use label to handle file input properly
        >
            {isUploading ? (
                <CircularProgress size={26} color="primary" />
            ) : (
                edit ? 'Edit CSV' : 'Upload CSV'
            )}
            <input
                id='inputCSV'
                type='file'
                accept='.csv,text/csv,application/vnd.ms-excel,application/csv,text/x-csv,application/x-csv,text/plain'
                onChange={handleFileUpload}
                hidden
            />
        </Button>
    );
}

export default Upload;